import { api } from "@api/api";
import { Landing } from "@modules/landings/types";
import { LandingFormValues } from "@modules/landings/validations";

export async function createLandingService(data: LandingFormValues): Promise<Landing> {
  const { phone_image, ...body } = data;

  const { data: landing } = await api.post<Landing>("v1/landing_admin/", body);

  if (phone_image && phone_image instanceof File) {
    const formData = new FormData();
    formData.append("phone_image", phone_image);

    await api.patch(`v1/landing_admin/${landing.id}/`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }

  return landing;
}
